// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from '../supports/dms-common';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from '@mui/material/FormControlLabel';
import CssBaseline from '@mui/material/CssBaseline';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import MsgDialog from './MsgDialog';


function UploadDialog(props) {

  const { open, onClose, onOk } = props;

  const [selFilename, setSelFilename] = useState("");

  const [file, setFile] = useState(null);
  const [useBlankUpload, setUseBlankUpload] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");


  useEffect(() => {
    if (open) {
      setSelFilename("");
      setFile(null);
      setUseBlankUpload(false);
      setShowError(false);
      setErrMsg("");
    }

  }, [open])

  const handleCloseClick = () => {
    onClose && onClose();
  }


  const handleSelectedUploadFile = (e) => {
    const vFileList = e.target.files;
    // console.log("handleSelectedUploadFile", vFileList);

    if (vFileList.length > 0) {
      const vFile = vFileList[0];

      setSelFilename(vFile.name)

      setFile(vFile);

    }

  }



  const handleChangeBlankUpload = (e) => {
    const isChecked = e.target.checked;

    setUseBlankUpload(isChecked);
  }

  const handleOkClick = () => {
    if (file && file.size > DmsCommon.MAX_FILE_SIZE) {
      setErrMsg("File size exceeds 2GB limit!");
      setShowError(true);
      return;
    }
    onOk && onOk(file, useBlankUpload);
  }


  const enableOkBtn = ((selFilename?.length > 0)) || useBlankUpload;

  const Input = styled('input')({
    display: 'none',
  });

  return (

    <Dialog
      fullWidth={true}
      maxWidth={"md"}
      open={open}
      onClose={handleCloseClick}
    >
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />
      <DialogTitle>Upload Document</DialogTitle>
      <DialogContent>

        <TextField
          label="Existing File"
          fullWidth
          sx={{ mt: 1 }}
          value={selFilename}
          disabled={useBlankUpload}
          InputLabelProps={{ shrink: true, }}
          InputProps={{
            readOnly: true,
            endAdornment:
              <InputAdornment position="end">
                <label htmlFor="icon-button-add-rev-file">
                  <Input id="icon-button-add-rev-file" type="file" onChange={handleSelectedUploadFile} />
                  <Button variant="contained" component="span" disabled={useBlankUpload} >
                    Select
                  </Button>
                </label>
              </InputAdornment>
          }}
        />
        <FormControlLabel
          sx={{ mt: 1 }}
          control={
            <Checkbox checked={useBlankUpload} onChange={handleChangeBlankUpload} name="chkBlankFile" />
          }
          label="Blank File"
        />

      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Close</Button>
        <Button variant="contained" disabled={!enableOkBtn} onClick={handleOkClick} >
          Ok
        </Button>
      </DialogActions>
    </Dialog>

  );
}

UploadDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onOk: PropTypes.func,
};

export default UploadDialog